module.exports = __webpack_public_path__ + "media/empty.689b9103.mp3";